module.exports = __webpack_public_path__ + "img/logo-valzum-app.ca6308d7.png";